
import appInfo from './config';

function submitCase(q) {
    const apiEndUrl = '/cases/new';
    let fullUrl = appInfo.server + apiEndUrl;

    return fetch(fullUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(q)
      })
      .then(response => response.json())
      .catch(error => {
        console.error(error);
      });
}

export default {
    submitCase
};
